import { FailedAgreementIcon } from "icons/action/FailedIcon";
import Button from "components/form/Button";
import { useNavigate, useParams } from "react-router-dom";
import {
  decode,
  encode,
  customerFacingPaymentError,
} from "utils/HelperFunctions";
import { useTestAttrsFactory } from "utils/testid";

type PaymentLinkProcessFailedProps = {
  handleBackToStart?: () => void;
  failedReason?: string | null;
  isRetry?: boolean;
  showUpdatePaymentMethod?: boolean;
  showDeclinedMessage?: boolean;
  title?: string;
};

const PaymentLinkProcessFailed = ({
  handleBackToStart,
  failedReason,
  isRetry = false,
  showUpdatePaymentMethod = true,
  showDeclinedMessage = true,
  title = "Payment failed",
}: PaymentLinkProcessFailedProps) => {
  const navigate = useNavigate();
  const { id, clusterId } = useParams();
  const testAttrs = useTestAttrsFactory();

  return (
    <div
      className="h-full flex items-center justify-center lg:pb-0 lg:pt-0 pt-5 pb-10"
      {...testAttrs("process-failed", "Payment link payment failed")}
    >
      <div
        className={`w-full ${
          !isRetry && "max-w-[630px] px-5"
        } flex flex-col justify-center items-center gap-6`}
      >
        <div className="w-full flex flex-col justify-center items-center gap-10">
          <FailedAgreementIcon aria-hidden="true" />
          <div className="w-full text-center text-xl text-txtPrimary font-medium">
            {title}
          </div>
          <div className="w-full text-center bg-bgThird lg:py-5 py-4 lg:px-2 px-3 lg:text-lg text-base text-txtParagraph break-words">
            {customerFacingPaymentError(failedReason) || "Payment Failed"}
          </div>
          {showDeclinedMessage && (
            <div className="w-full text-center text-txtParagraph lg:text-xl">
              Sorry! Your payment method was declined.
            </div>
          )}
          {showUpdatePaymentMethod && handleBackToStart && (
            <div>
              <Button
                text={"Update payment method"}
                className="text-base px-11"
                {...testAttrs("update-payment-method", "Update payment method")}
                onClick={handleBackToStart}
              />
            </div>
          )}
        </div>
        <div className="w-full lg:text-base text-sm text-center text-btnPrimaryActive hover:!text-btnPrimaryHover ">
          <div
            className="cursor-pointer"
            role="button"
            tabIndex={0}
            {...testAttrs("back-to-dashboard", "Back to dashboard")}
            onClick={() => {
              let clusterid = clusterId
                ? clusterId
                : encode(decode(id || "")?.split("_")[1], "ci_");
              navigate(`/${clusterid}/dashboard`);
            }}
          >
            Back to dashboard
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentLinkProcessFailed;
